module.exports = __webpack_public_path__ + "dda0e5c84f1d80b117fb200dd08a0021.svg";